import React from 'react';
import ROUTE_PATH from '../../../routes/config';
import { useNavigate } from 'react-router-dom';
import { LoanSectionWrap } from '../style';
import FeatherIcon from 'feather-icons-react/build/FeatherIcon';

const LoanSection = ({ creditGoodsData }) => {
  const navigate = useNavigate();
  return (
    <LoanSectionWrap className="loanSectionWrap">
      <h3 className="title">
        대출 가능한 상품을
        <br />
        한눈에 확인하세요
      </h3>
      <ul>
        {creditGoodsData.list?.results.map((item, index) => {
          return (
            <li key={`${item.creditGoodsMasterEventSeq}-${index}`}>
              <img src={item.financeLogoUrl} alt="" />
              <dl>
                <dt>{item.creditGoodsName}</dt>
                <dd>
                  <span>{item.financeInstitutionName}</span>
                  <span>{item.dataUseTypeNm}</span>
                </dd>
                <dd>{item.creditGoodsDescription}</dd>
              </dl>
              <button
                type="button"
                className="btnMove"
                onClick={() => navigate(ROUTE_PATH.mypage.checkLoan)}
              >
                <FeatherIcon
                  icon="chevron-right"
                  size={20}
                  strokeWidth={2}
                  stroke="#02A4FF"
                />
              </button>
            </li>
          );
        })}
      </ul>
      {creditGoodsData.overAllHasMore && (
        <button
          type="button"
          className="btnCheckMyLoanLimit"
          onClick={() => navigate(ROUTE_PATH.mypage.checkLoan)}
        >
          대출 상품 더 알아보기
        </button>
      )}
    </LoanSectionWrap>
  );
};

export default LoanSection;
